"use client"
import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
  useEffect
} from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  selectConfig,
  selectCurrencyRates,
  selectMenuConfigList
} from "@src/store/selectors/config"
import { selectUser } from "@src/store/selectors/user"
import { ConfigType } from "@src/types/api"
import { ConfigState } from "@src/types/state"
import { setUser, UserState } from "@src/store/slices/userSlice"

const defaultCtx = {
  config: null as ConfigState | null,
  menuConfigList: [],
  onSaleColor: "" as string | null,
  user: {} as UserState,
  refetch: () => {},
  locale: "vi",
  setLocale: (lang: string) => {},
  messages: {} as any,
  currencyRates: [] as string[]
}

const LayoutContext = createContext(defaultCtx)

interface Props {
  children: any
  rootConfig?: ConfigType
}

export const LayoutProvider = ({ children, rootConfig }: Props) => {
  const config = useSelector(selectConfig)
  const currencyRates = config?.currencyRates
  const menuConfigList = useSelector(selectMenuConfigList)
  const user = useSelector(selectUser)
  const [locale, setLocale] = useState("en")
  const [messages, setMessages] = useState({})
  const handleRefetch = useCallback(() => {}, [])

  const onSaleColor = useMemo(() => {
    return config?.on_sale ? "#D8042C" : null
  }, [config?.on_sale])
  return (
    <LayoutContext.Provider
      value={{
        config,
        menuConfigList,
        user,
        refetch: handleRefetch,
        currencyRates,
        onSaleColor,
        locale,
        setLocale,
        messages
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export function useLayoutContext() {
  return useContext(LayoutContext)
}
